window.dataLayer = window.dataLayer || [];

import { pushToDataLayer } from '@/ui/scripts/analytics/analytics.methods';
import Plyr from 'plyr';

const elements = {
  videoCards: [...document.querySelectorAll('.js-video-card')],
};
const titleClass = '.js-card-title-ga';

const updateCardGA = {
  eventName: 'updateCardVideo_tracking',
  actionPropTitle: 'updateCardVideo_action',
  labelPropTitle: 'updateCardVideo_label',
  elementClass: 'js-update-card-ga',
};

const videoCardGA = {
  eventName: 'cardListingVideo_tracking',
  actionPropTitle: 'cardListingVideo_action',
  labelPropTitle: 'cardListingVideo_label',
  elementClass: 'js-video-card-ga',
};

function handleVideoClick(label, card, title) {
  if (card.classList.contains(videoCardGA.elementClass)) {
    pushToDataLayer(
      videoCardGA.eventName,
      videoCardGA.actionPropTitle,
      videoCardGA.labelPropTitle,
      `Video - ${title ? title : `No title`}`,
      label,
    );
  } else if (card.classList.contains(updateCardGA.elementClass)) {
    pushToDataLayer(
      updateCardGA.eventName,
      updateCardGA.actionPropTitle,
      updateCardGA.labelPropTitle,
      `Video - ${title}`,
      label,
    );
  }
}

function addVideo(card, title) {
  const videoEmbed = card.querySelector('.js-video-embed');
  const poster = videoEmbed.getAttribute('data-poster');
  const ratio = videoEmbed.getAttribute('data-ratio');

  const cardPlayer = new Plyr(videoEmbed, {
    controls: ['play', 'pause'],
    autoplay: false,
    loop: { active: false },
    clickToPlay: false,
    hideControls: false,
    ratio: ratio ? ratio : '3:2',
    vimeo: {
      title: true,
      responsive: true,
    },
  });

  if (poster) {
    cardPlayer.on('ready', () => {
      cardPlayer.poster = poster;
    });
  }

  //GA handlers (Play/Pause)
  cardPlayer.on('play', () => {
    handleVideoClick('Play', card, title);
  });
  cardPlayer.on('pause', () => {
    handleVideoClick('Pause', card, title);
  });
}

function init() {
  if (elements.videoCards.length > 0) {
    elements.videoCards.forEach((el) => {
      const title = el.querySelector(titleClass)?.textContent.trim();

      addVideo(el, title);
    });
  }
}

export default init;
